// Shared identity for the Space list; legacy names remain stable after a rename.
function spaceTokenListName(ownerUid, profile = {}) {
    return profile.pageTokenListName || (profile.muultiName ? profile.muultiName + "TokenList" : ownerUid + "TokenList");
}

function spaceTokenListDocumentId(ownerUid) {
    return "spaceTokens_" + ownerUid;
}

module.exports = { spaceTokenListName, spaceTokenListDocumentId };
